import { usePaymentsConfig } from '@/services/paymentsConfig/usePaymentsConfig';
import { useSelectedProvider } from '@/features/paymentSelect/useSelectedProvider';
import StripeContainer from '@/providers/stripe/StripeContainer';
import PaypalContainer from '@/providers/paypal/PaypalContainer';

import ProvidersLibsContextProvider from './ProvidersLibsContextProvider';
import ProvidersLibsLoader from './ProvidersLibsLoader';

function ProvidersLibsContainer({ children }: { children: React.ReactElement }) {
  const { isProviderAvailable } = usePaymentsConfig();
  const { isSelectedProvider } = useSelectedProvider();

  return (
    <ProvidersLibsContextProvider>

      <StripeContainer enabled={isSelectedProvider('STRIPE')}>
        <PaypalContainer enabled={!!isProviderAvailable('single', 'PAYPAL')}>
          {children}
        </PaypalContainer>
      </StripeContainer>

      <ProvidersLibsLoader />

    </ProvidersLibsContextProvider>
  );
}

export default ProvidersLibsContainer;
